import { useMatch } from 'react-router-dom'

export const useInternalRouteMatch = () => {
  const match = useMatch('/internal/*')

  return match
}
